import { combineReducers } from 'redux';

import {
  getCustomerListRequest,
  getCustomerListSuccess,
  getCustomerListFail,
  setCustomerListDirty,
  clearCustomerList,
} from '../actions';
import { CustomerAction } from '../types';
import { Customer } from '../../../../types/items';
import { ItemList } from '../../../../types/main';
import { Loadable, Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<Customer>>;
type ReducerOf<T extends keyof State> = Reducer<State, CustomerAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getCustomerListRequest.type:
      return state ? stripItems(state) : null;

    case getCustomerListSuccess.type:
      return action.payload;

    case clearCustomerList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getCustomerListRequest.type:
      return true;

    case getCustomerListSuccess.type:
    case getCustomerListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setCustomerListDirty.type:
      return action.payload;

    case getCustomerListSuccess.type:
    case getCustomerListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
